/* eslint-disable semi */
<style scoped lang="less">
.layout{position: absolute; background: rgba(2, 36 ,38,.5);-webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2)); filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));overflow: hidden;border-radius: 10px; bottom: 12px;height: 680px; top: 50%;left: 50%;transform: translate(-50%, -50%);}
.title{width: 910px; height: 35px;background: rgba(33, 185, 191, 0.6);margin: 0;line-height: 35px;text-align: right;padding: 0 20px;color: #fff; font-size: 16px;display: flex;justify-content: space-between;}
.ol-popup-closer:after {content: "✖";}
.attribute{width:950px;display: flex;flex-wrap: wrap;}
#TMap{width:703px; height:465px;}
.legend{width:246px;height:465px;margin:0;padding:0;overflow: auto;
  li{display: flex; margin: 10px 0;
    img{height: 30px;width: 30px; margin: 0 20px;}
    p{line-height: 30px; color: #fff;margin: 0;}
  }
}
.table{width: 950px;}
</style>

<template>
  <div class="layout" v-drag v-show="flag">
    <p class="title">
      <span>三维模型</span>
      <a href="#" id="popup-closer" class="ol-popup-closer" @click="closePul(false)"></a>
    </p>
    <div class="attribute">
      <div id="TMap"></div>
      <ul class="legend">
        <li v-for="(item, index) in ModLegend" :key="index">
          <img :src="item.url" alt="">
          <p>{{item.legname}}</p>
        </li>
      </ul>
      <div class="table">
        <ModeAttbute></ModeAttbute>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import * as Three from 'three'
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import ModeAttbute from './ModeAttbute'
export default {
  components: {ModeAttbute},
  props: ['minemodel'],
  data()
  {
    return {
      flag: false,
      renderer: '',
      scene: '',
      camera: '',
      mineurl: [],
      groupname: '',
      legend: []
    }
  },
  computed:
  {
    ...mapState({
      minedata: state => state.minedata
    }),
    ModLegend()
    {
      return this.legend
    }
  },
  watch: {
    minedata:
    {
      handler(nval, oval)
      {
        if (nval.bool === true)
        {
          this.flag = true
          this.$nextTick(() =>
          {
            if (this.scene)
            {
              //销毁场景中的模型
              this.removerMod()
              return this.loadGLTF()
            }
            this.initRender('TMap')
            this.initCamera()
            this.initScene()
            this.initLight()
            // 坐标轴
            this.addAxesHelper()
            this.loadGLTF()
            // 控制器
            this.initControls()
            this.animate()
          })
        }
        this.mineurl = nval.url
        this.groupname = nval.name
        this.route = nval.route
      },
      deep: true
    }
  },
  methods:
  {
    //关闭插件
    closePul(show)
    {
      this.flag = show
      //销毁场景中的模型
      this.removerMod()
    },
    initRender(containerid)
    {
      this.renderer = new Three.WebGLRenderer({ antialias: true, alpha: true })
      this.renderer.setSize(document.querySelectorAll('#TMap')[0].clientWidth, document.querySelectorAll('#TMap')[0].clientHeight)
      this.renderer.setClearColor(0x070628, 0)
      document.getElementById(containerid).appendChild(this.renderer.domElement)
    },
    initCamera()
    {
      this.camera = new Three.PerspectiveCamera(
        90,
        document.querySelectorAll('#TMap')[0].clientWidth / document.querySelectorAll('#TMap')[0].clientHeight,
        0.1,
        5000
      )
      this.camera.position.set(-87, 120.6, 640.5)
      window.camera = this.camera
    },
    initScene()
    {
      this.scene = new Three.Scene()
      window.scene = this.scene
    },
    animate()
    {
      this.renderer.render(this.scene, this.camera)
      this.controls.update()
      // 更新性能插件
      requestAnimationFrame(this.animate)
    },
    initLight()
    {
      this.scene.add(new Three.AmbientLight(0xffffff))
      this.light = new Three.DirectionalLight(0xffffff, 0.7)
      this.light.position.set(1, 1, 1)
      this.scene.add(this.light)
    },
    addAxesHelper()
    {
      let axesHelper = new Three.AxesHelper(200)
      this.scene.add(axesHelper)
    },
    // 加载GLTF模型
    loadGLTF()
    {
      this.group = new Three.Group()
      let that = this
      let loader = new GLTFLoader()
      let subUrl = this.route.substring(0, this.route.lastIndexOf('/') + 1)
      this.mineurl.forEach(data =>
      {
        let legendimg = data['岩性花纹'] || data['岩土名称']
        let index = this.legend.findIndex(e => e.legname === legendimg)
        if (index === -1)
          this.legend.push({url: `static/images/${this.groupname}/${legendimg}.png`, legname: legendimg})
        let modurl = subUrl + data.path
        loader.load(modurl, object =>
        {
        // 新建一个模型对象
          that.personmesh = new Three.Mesh()
          let model = object.scene.children[0]
          that.personmesh.add(model)
          this.group.add(that.personmesh)
        })
      })
      this.group.name = this.groupname
      that.scene.add(this.group)
    },
    initControls()
    {
      this.controls = new OrbitControls(this.camera, this.renderer.domElement)
      // 如果使用animate方法时，将此函数删除
      // controls.addEventListener( 'change', render );
      // 使动画循环使用w时阻尼或自转 意思是否有惯性
      this.controls.enableDamping = false
      // 动态阻尼系数 就是鼠标拖拽旋转灵敏度
      this.controls.zoomSpeed = 0.3
      // 是否可以缩放
      this.controls.enableZoom = true
      // 是否自动旋转
      this.controls.autoRotate = false
      // 设置相机距离原点的最远距离
      this.controls.minDistance = 20
      // 设置相机距离原点的最远距离
      this.controls.maxDistance = 1000000
      // 是否开启右键拖拽
      this.controls.enablePan = true
    },
    removerMod()
    {
      // 递归遍历组对象group释放所有后代网格模型绑定几何体占用内存
      this.group.traverse(function(obj)
      {
        if (obj.type === 'Mesh')
        {
          obj.geometry.dispose()
          obj.material.dispose()
        }
      })
      // 删除场景对象scene的子对象group
      this.scene.remove(this.group)
      //清空图例
      this.legend = []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/Minemodel.vue